import { Injectable } from "@angular/core";
import { FeatureBranchCookieService } from "./feature-branch-cookie.service";
import { isNotStageP } from "src/app/utils/storebrand-staging";
import { parseFeatureEnvCookie } from "src/app/services/feature-env/feature-env-cookie";
import { FRONTEND_REPO } from "src/app/services/feature-env/feature-env.model";

@Injectable({ providedIn: "root" })
export class FeatureBranchInfoService {
  constructor(private readonly featureBranchCookieService: FeatureBranchCookieService) {}

  isNotProdEnv(): boolean {
    return isNotStageP();
  }

  getFeatureBranchInfo(): {
    isFeatureBranch: boolean;
    currentRepo: string;
    featureBranchName?: string;
  } {
    const currentRepo = FRONTEND_REPO;
    if (!this.isNotProdEnv()) {
      return { isFeatureBranch: false, currentRepo };
    }

    // The cookie may carry several repos, e.g. a frontend branch and a backend
    // branch at once. Only this repo's entry describes the page you are on.
    const branch = parseFeatureEnvCookie(this.featureBranchCookieService.getFeatureBranchCookie()).find(
      (env) => env.repo === currentRepo,
    )?.branch;

    return {
      isFeatureBranch: !!branch,
      currentRepo,
      featureBranchName: branch,
    };
  }
}
